import { intersect, partial, struct } from 'io-ts/Decoder';

import { Id as OrganizationId } from '../../../../organization/Id';
import { Id as MaterialTemplateId } from '../../../../whole-house/material-template/Id';

export const Request = intersect(
	struct({
		organizationId: OrganizationId,
	})
)(
	partial({
		materialTemplateId: MaterialTemplateId,
	})
);
